import ParametersTable from "./ParametersTable";
import styles from "components/product/detail/parameters/ParameterGroup.module.scss";

const ParameterGroup = ({ title, parameters }) => {
  return (
    <div className={styles["parameterGroup"]}>
      {title ? (
        <h3 className={styles["parameterGroup__title"]}>{title}</h3>
      ) : (
        ""
      )}
      <ParametersTable parameters={parameters} />
    </div>
  );
};

export default ParameterGroup;
